/**
 * 要素の line-height をピクセル数で返す
 * @param {HTMLElement} el
 * @returns {number}
 */
export function getLineHeightPx(el) {
	const lh = getComputedStyle(el).lineHeight;
	if (lh === 'normal') {
		return parseFloat(getComputedStyle(el).fontSize) * 1.2;
	}
	return parseFloat(lh);
}

/**
 * 要素の font-size をピクセル数で返す
 * @param {HTMLElement} el
 * @returns {number}
 */
export function getFontSizePx(el) {
	return parseFloat(getComputedStyle(el).fontSize);
}
